
import { Vue, Component } from 'vue-property-decorator'
import Footer from '@mg/web-components/Footer'
import { FooterProps } from '@mg/web-components/Footer/types'
import Loader from '@mg/web-components/Atoms/Loader'
import {
  GET_CONTENT_BY_TITLE,
  GQLGetContentByTitleQueryInput,
} from '~/graphql/gql/content'
import { GQLCncLink, GQLContent } from '~/graphql/__generated__/interfaces'
import { GET_CNC_LINKS } from '~/graphql/gql/cncLinks'
import { Shops } from '~/config/shops'

const CNC_COLUMN_INDEX = 4

@Component({
  apollo: {
    getCncLinks: {
      query: GET_CNC_LINKS,
      skip(): boolean {
        return this.$shopConfig.shopId !== Shops.CZ10MA
      },
    },
    getContentByTitle: {
      query: GET_CONTENT_BY_TITLE,
      update(data: { getContentByTitle: GQLContent }) {
        try {
          if (data.getContentByTitle.body) {
            return JSON.parse(data.getContentByTitle.body)
          }
        } catch (e) {
          this.$logger.error(
            `TheFooterDynamic - getContentByTitle query update - json is not valid : ${e}`,
            e
          )
        }

        return null
      },
      variables: {
        title: 'nxt_footer',
      } as GQLGetContentByTitleQueryInput,
    },
  },
  components: { Footer, Loader },
})
export default class TheFooterDynamic extends Vue {
  getContentByTitle: FooterProps
  getCncLinks: GQLCncLink[]

  get items() {
    // for SPA development - fixes 404 for `http://localhost/i/document/*`
    const monolithUrl = (link: string): string => {
      if (link.startsWith('/')) {
        return (this.$env?.monolithUrl ?? '') + link
      }
      return link
    }

    if (this.getContentByTitle.partner?.items?.length) {
      this.getContentByTitle.partner.items = this.getContentByTitle.partner?.items.map(
        (item) => ({
          ...item,
          hoverImageUrl: monolithUrl(item.hoverImageUrl),
          imageUrl: monolithUrl(item.imageUrl),
        })
      )
    }

    if (!this.getContentByTitle?.interest?.items?.length) {
      return this.getContentByTitle
    }

    this.getContentByTitle.interest.items[CNC_COLUMN_INDEX].items =
      this.getCncLinks?.map((item) => {
        return {
          href: item.link,
          mark: false,
          name: item.title,
        }
      }) ?? []
    return this.getContentByTitle
  }
}
